import React from 'react'
import { Grid } from 'react-styled-flexboxgrid'
import { ThemeProvider } from 'styled-components'

import FlexBoxGridTheme from './tableTheme'

import InputRowNoPassword from "./InputRowNoPassword"

const InputRow = () => {
  return (
  <ThemeProvider theme={FlexBoxGridTheme}>
    <Grid fluid>
      <InputRowNoPassword/>
    </Grid>
  </ThemeProvider>
  )
}

export default InputRow
